import { defineComponent as e, Types as t } from "bitecs";
const i = e({
  target: t.eid,
  inputSource: t.eid,
  currentYaw: t.f32,
  currentPitch: t.f32,
  currentDistance: t.f32,
  targetYaw: t.f32,
  targetPitch: t.f32,
  targetDistance: t.f32,
  minDistance: t.f32,
  maxDistance: t.f32,
  minPitch: t.f32,
  maxPitch: t.f32,
  smoothness: t.f32,
  offsetX: t.f32,
  offsetY: t.f32,
  offsetZ: t.f32,
  sensitivity: t.f32,
  zoomSensitivity: t.f32
});
export {
  i as OrbitCamera
};
//# sourceMappingURL=components.js.map
